import { parse } from '@vanillaes/csv'
import L from 'leaflet';

async function fetchCSV() {
  try {
    const response = await fetch("/swimming.csv");
    if (!response.ok) {
      throw new Error(`Response status: ${response.status}`);
    }

    const result = await response.text();
    return result;
  } catch (error) {
    console.error(error.message);
  }
}
function textToJsonArray(text) {
  const csv = parse(text);
  const o = [];
  for (var i = 1; i < csv.length; ++i)
  {
    const it = {};
    for (var j = 0; j < csv[0].length; ++j)
      it[csv[0][j]] = csv[i][j];
    o.push(it);
  }
  return o;
}
function dataToGeoJson(data) {
  return data.map((x) => {
    const o = {
      "type": "Feature",
      "properties": {
          "description": x.Description,
          "events": x.Events ? x.Events.split("\n").filter(e => !(/^\s*$/.test(e))).map(e => e.split("; ")) : [],
          "link": x.Link,
          "name": x.Name,
          //"show_on_map": true,
          "type": x.Type,
          "usage": x.Usage,
      },
      "geometry": {
          "type": "Point",
          // Achtung: GeoJSON switches long and lat around
          "coordinates": [parseFloat(x.Longitude.replace(",", ".")), parseFloat(x.Latitude.replace(",", "."))],
      },
    };
    return o;
  });
}

function makeLink(txt, href, suffix="") {
  return `<a href="${href}" rel="noopener noreferrer" target="_blank">${txt} 🔗</a>`;
}
function linkOrText(txt, href, suffix="") {
  return href ? makeLink(txt, href, suffix) : txt;
}

function onEachFeature(feature, layer) {
  const titleText = linkOrText(feature.properties.name, feature.properties.link, " 🔗");
  const eventsText = (feature.properties.events && feature.properties.events.length > 0) ? ("<h5>Events 📅</h5><ul>" + feature.properties.events.map(e => e.length > 1 ? linkOrText(e[0], e[1]) : e[0]).map(e => `<li>${e}</li>`).join("\n") + "</ul>") : "";
  layer.bindPopup(`<div class="content"><h4><span class="tag is-info mr-1">${feature.properties.type}</span>${titleText}</h4><h5 class="has-text-right">Usage: <i>${feature.properties.usage}</i></h5><p>${feature.properties.description}</p>${eventsText}</div>`);
}
async function setupMap() {
  // Fetch and process data
  const geojson = dataToGeoJson(textToJsonArray(await fetchCSV()));
  const map = L.map('map').setView([51.0764,13.7727], 4);
  // TODO: Check tile usage policy
  // https://operations.osmfoundation.org/policies/tiles/
  L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 18,
      attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
      // See: https://wiki.openstreetmap.org/wiki/Referer
      referrerPolicy: "strict-origin-when-cross-origin",
  }).addTo(map);
  // https://leafletjs.com/examples/geojson/
  L.Icon.Default.prototype.options.imagePath = '/vendor/images/';
  L.geoJSON(geojson, {
      onEachFeature: onEachFeature,
  }).addTo(map);
}

setupMap();
